(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignSpamFilter', {
    bindings: {
      currentSpamFilterSettings: '<',
      canSave: '<',
      onSave: '&'
    },
    controller: CampaignSpamFilterFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/campaigns/campaign-spam-filter.component.html'
  });

  function CampaignSpamFilterFormController(
    $filter

  ) {
    'ngInject';

    const vm = this;

    vm.saveSettings = saveSettings;

    function saveSettings(){
      const settings = vm.currentSpamFilterSettings;

      return vm.onSave({
        settings: {
          blockDuplicatesForSeconds: settings.blockDuplicatesForSeconds != null
            ? settings.blockDuplicatesForSeconds
            : $filter('translate')('CAMPAIGN_SPAM_INTERVAL_DEFAULT'),
          trackAnonymous: !!settings.trackAnonymous
        }
      });
    }
  }
})();
